// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__m9B49","Button__clicked":"styles_Button__clicked__iBJbG"};